const blogPage = document.querySelector(".blog-index");
const locationIndex = document.querySelector(".location-index");

function filterArticles(articles, criteria) {
	if (articles.length > 0 && criteria) {
		articles[0].parentElement.classList.remove("visible");
		if (criteria == "all") {
			articles.forEach((art) => {
				art.style.display = "block";
			});
		} else {
			articles.forEach((art) => {
				if (art.dataset.term.indexOf(criteria) != -1) {
					art.style.display = "block";
				} else {
					art.style.display = "none";
				}
			});
		}
		setTimeout(() => {
			articles[0].parentElement.classList.add("visible");
		}, 250);
	}
}

if (blogPage || locationIndex) {
	const parent = blogPage ? blogPage : locationIndex;
	const filter = parent.querySelector(".filter");
	let articles = "";

	if (blogPage) {
		articles = parent.querySelectorAll(".article");
	} else {
		articles = parent.querySelectorAll('.location')
	}

	if (filter) {
		const buttons = filter.querySelectorAll(".js-filter-button");

		buttons.forEach((btn) => {
			btn.addEventListener("click", (e) => {
				buttons.forEach((el) => {
					if (el == e.target) {
						el.parentElement.classList.add("active");
					} else {
						el.parentElement.classList.remove("active");
					}
				});
				filterArticles(articles, e.target.dataset.cat);
			});
		});
	}

	const activeButton = parent.querySelector(".filter li.active");
	if (activeButton) {
		activeButton.querySelector("button").click();
	} else {
		blogPage.querySelector('.filter li button[data-cat="all"').click();
	}
}
